$mol_icon_arrow_left_bold $mol_icon path \M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z
